import React from 'react';
import Typography from '@mui/material/Typography';
import FormDialog from '../../../../../components/Dialog/FormDialog';

const ArchiveDialog = ({
  open,
  onClose,
  onSubmit,
  loading,
  isArchive,
}) => {
  return (
    <FormDialog
      open={open}
      handleClose={onClose}
      handleSubmit={onSubmit}
      loading={loading}
      buttonTxt={isArchive ? "Restore" : "Archive"}
      title={
        isArchive
          ? "Confirmation: Restore Board"
          : "Confirmation: Archive Board"
      }
      alignActions={"center"}
      cancelBtn={true}
      fullWidth={true}>
      <Typography className="align_text_center mb-2">
        {isArchive
          ? "Are you sure you want to restore the board ?"
          : "Are you sure you want to archive this board? Archiving the board will hide it from view and move it to the archive section. You can always restore it later if needed. Please confirm your action."}
      </Typography>
    </FormDialog>
  );
};

export default ArchiveDialog; 